<template>
  <div class="typeThree">
    <div class="typeThree-item" v-for="(item,index) in part3" :key='index'>
      <div class="left">
        <div class="left-title">{{item.title||''}}</div>
        <div class="left-desc">{{item.desc||''}}</div>
        <div class="left-btn">{{item.btnText||''}}</div>
      </div>
      <div class="right">
        <img :src="require(`../assets/${item.imgSrc}`)" >
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'typeThree',
    props:{
      part3:{
        type:Array,
        default:[]
      }
    }
  }
</script>

<style scoped lang="less">
  .typeThree{
    border-bottom: 10px solid #F9F9F9;
    .typeThree-item{
      padding: 20px 0;
      padding-bottom: 190px;
      width: 90%;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      position: relative;
      &:nth-child(1){
        padding-bottom: 116px;
      }
      &:nth-child(2){
        padding-bottom: 160px;
      }
      .right{
        // flex: 0 0 200px;
        width: 200px;
        // height: 200px;
        position: absolute;
        top: 85px;
        img{
          width: 100%;
          height: 100%;
          display: block;
        }
      }
      &:nth-child(odd){
        .right{
          right: 0;
        }
      }
      &:nth-child(even){
        flex-direction: row-reverse;
        .right{
          left: 0;
        }
        .left{
          // display: flex;
          flex-direction: column;
          align-items: end;
          .left-btn{
            float: right;
          }
        }
        .left-title{
          width: 100%;
          text-align: right;
        }
        .left-desc{
          text-align: right;
        }
      }
      .left{
        flex: 0 0 240px;
        .left-title{
          font-size: 16px;
          font-weight: bold;
          line-height: 16px;
          color: #333333;
          margin-bottom: 10px;
        }
        .left-desc{
          font-size: 14px;
          color: #555555;
        }
        .left-btn{
          margin-top: 20px;
          width: 98px;
          height: 26px;
          background-color: #726AF9;
          color: #fff;
          font-size: 14px;
          line-height: 14px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 6px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/typeThree.vue